import { useMemo } from "react";

import { SecondaryAlert } from "@/Components/v2/atoms/Alert";
import { BoldSpan } from "@/Components/v2/atoms/Typography";
import { useInfo } from "@/context/InfoProvider/InfoProvider";

interface NodeHierarchyAlertProps {
  nodeUUID: string;
  rootLevelLabel?: string | null;
}

const HIERARCHY_SEPARATOR = ">";

export const NodeHierarchyAlert: React.FC<NodeHierarchyAlertProps> = ({
  nodeUUID,
  rootLevelLabel = null,
}) => {
  const { nodes, loading } = useInfo();

  const selectedNodeHierarchy = useMemo(() => {
    if (!nodeUUID || !nodes) return null;

    const ancestors = nodes.getNodeAndAncestors(nodeUUID);
    if (ancestors.length === 0) return null;

    if (rootLevelLabel !== null) {
      const rootNode = ancestors[ancestors.length - 1];
      return `${rootNode!.warchestNode.extras.mappedName || rootNode!.warchestNode.name} ${HIERARCHY_SEPARATOR} ${rootLevelLabel}`;
    }

    return ancestors
      .reverse()
      .map((node) => node.warchestNode.extras.mappedName || node.warchestNode.name)
      .join(` ${HIERARCHY_SEPARATOR} `);
  }, [nodeUUID, nodes, rootLevelLabel]);

  if (loading) return null;

  return (
    <SecondaryAlert severity="info" icon={false}>
      <BoldSpan>Showing: </BoldSpan> {selectedNodeHierarchy}
    </SecondaryAlert>
  );
};

export default NodeHierarchyAlert;
